import {fetchHelper, simulateDelay} from '../utils/requestUtils';

export const getMonthlyReportMany = async (sortObj) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "GET",
        url: "/monthlyReports/getMany",
    })
    return response;
}

export const getInstantAmounts = async () => {
    try {
        await simulateDelay();
        const response = await fetchHelper({
            method: "GET",
            url: "/monthlyReports/getInstantAmountsBySourceType",
        })
        return response;
    } catch (e) {
        console.log(e);
    }

}
